import { styled } from 'linaria/lib/react';
import React from 'react';
import { BurgerAvatar } from './BurgerAvatar';
export const BurgerMenu = ({
  onClick,
  children
}: {
  onClick?: () => void;
  children: React.ReactNode;
}) => <WrapperLogo>
    <BurgerAvatar onClick={onClick} />
    {children}
  </WrapperLogo>;
const WrapperLogo = /*#__PURE__*/styled("div")({
  name: "WrapperLogo",
  class: "wqqzule"
});

require("./BurgerMenu.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./BurgerMenu.tsx");